<template>
  <el-dialog
        :title="$t('deposit.TransactionSettlement')"
        :visible="visible"
        width="70%"
        top="5vh"
        append-to-body
        @close="handleClose"
    >
    <!-- 明细表格 -->
    <el-table :data="tableData" style="width: 100%" v-loading="loading" border height="50vh">
      <el-table-column prop="trTsId" :label="$t('deposit.rsId')" width="180" />
      <el-table-column prop="trNo" :label="$t('deposit.trNo')" width="240" />
      <el-table-column prop="gwNo1" :label="$t('deposit.rsdGwNo')" width="180" />
      <el-table-column prop="trCurrency" :label="$t('deposit.rsdTrCurrency')" width="180" />
      <el-table-column prop="trSettCurrency" :label="$t('deposit.rsdSettCurrency')" width="180" />
      <el-table-column prop="trSettRate" :label="$t('deposit.trSettRate')" width="180" />
      <el-table-column prop="trAmount" :label="$t('deposit.trAmount')" width="180" />
      <el-table-column prop="trStatus" :label="$t('deposit.trStatus')" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.trStatus === -2">{{$t('deposit.trStatus_2')}}</span>
          <span v-else-if="scope.row.trStatus === -1">{{$t('deposit.trStatus_1')}}</span>
          <span v-else-if="scope.row.trStatus === 0">{{$t('deposit.trStatus0')}}</span>
          <span v-else-if="scope.row.trStatus === 1">{{$t('deposit.trStatus1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trReseverRate" :label="$t('deposit.trReseverRate')" width="180" />
      <el-table-column prop="trDatetime" :label="$t('deposit.trDatetime')" width="180" />
      <el-table-column prop="trRefundment" :label="$t('deposit.trRefundment')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trRefundment === 0">{{$t('deposit.trRefundment0')}}</span>
          <span v-else-if="scope.row.trRefundment === 1">{{$t('deposit.trRefundment1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trProtest" :label="$t('deposit.trProtest')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trProtest === 0">{{$t('deposit.trProtest0')}}</span>
          <span v-else-if="scope.row.trProtest === 1">{{$t('deposit.trProtest1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trCongeal" :label="$t('deposit.trCongeal')" width="180" >
        <template slot-scope="scope">
          <span v-if="scope.row.trCongeal === 0">{{$t('deposit.trCongeal0')}}</span>
          <span v-else-if="scope.row.trCongeal === 1">{{$t('deposit.trCongeal1')}}</span>
          <span v-else>{{$t('unknownStatus')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="trRefundmentAmount" :label="$t('deposit.trRefundmentAmount')" width="180" />
      <el-table-column prop="trProtestAmount" :label="$t('deposit.trProtestAmount')" width="180" />
      <el-table-column prop="trCongealAmount" :label="$t('deposit.trCongealAmount')" width="180" />
    </el-table>

    <!-- 独立的分页器 -->
    <div style="margin-top: 15px; display: flex; justify-content: flex-end;">
      <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :total="pagination.total"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'TransferFundsDetail',
  // 2. 定义 Props
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      // 3. 定义组件内部状态
      loading: false,
      tableData: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    };
  },
  methods: {
    // 4. 定义方法
    async fetchData() {
      if (!this.rowId) return;
      this.loading = true;
      try {
        const res = await this.$axios.post('/api/deposit/transaction', {
          id: this.rowId,
          page: this.pagination.page,
          limit: this.pagination.limit
        });

        if (res.data.code === 0) {
          const responseData = res.data.data;
          this.tableData = res.data.data.records || [];
          this.pagination.total = Number(res.data.data.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询明细失败:', err);
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      // 关闭时，通过 update:visible 事件通知父组件
      this.$emit('close');
      this.tableData = [];
      this.pagination.total = 0;
    },
    handleSizeChange(newLimit) {
      this.pagination.limit = newLimit;
      this.fetchData();
    },
    handleCurrentChange(newPage) {
      this.pagination.page = newPage;
      this.fetchData();
    }
  },
  watch: {
    // 5. 监听 props 变化
    visible(newVal) {
      if (newVal) {
        this.pagination.page = 1; // 每次打开强制回到第一页
        this.fetchData();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/view/reserveSettlement/TransactionSettlement.vue